export default {
  idleTimeout: 180,
  partnerHub: 'https://hub-dev.chaserhq.com',
  apiUrl: 'http://localhost:9091',
  drmApiUrl: 'http://localhost:9200',
  cspReportUri:
    'https://sentry.chaserhq.com/api/5/security/?sentry_key=0c14462d45804f868521aa57b750ca2f',
  chargebeeSite: 'chaser-test',
  sentryDsn: 'https://0c14462d45804f868521aa57b750ca2f@sentry.chaserhq.com/5',
  sentryEnvironment: 'local',
  firebaseProjectId: 'chaser-dev',
  firebaseApiKey: 'AIzaSyAW-bVAQopSNSop_HvtWZm1Hnoe-XDqHIs',
  firebaseAppId: '1:461949490691:web:13affc5436f015cf60e036',
  pendoAgentId: undefined,
  enableDevToolsExtension: '1',
  enableLogs: '1',
};
